/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BrowserPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABBElEQVR4nO2VQW7CQAxFs+q+XZVuuEdVLhCwPalk2YQ7IFbkCuFaRBylXXGBdpNqmjCKCIQJmQ0IS18aTaT/5B/HiaJH+RQzP6GRDZB8o9FyiMDIFxrNracD2IuhxthW7gA1tSSS95mZf3SdsUcnzQ7+L60JkUy6zthDLUBoRQ5AUoQ2B6Pb6H4KjO6CvwOSwgEGZU36A6RrRH2zApLM3gWbIiDJWomQZMEASbIYuZjrWGLm1yAAINkfezS62F8FAJtvosvpNH1uxtL6uE499ASsujzOjGm17HzEzC/eo30Y1T7rmmuAz3px66L64Wh+qRMg+Y0/03HviEIU3j6ApDi1ov8AYJJg/suI1TMAAAAASUVORK5CYII=)
 */
export const BrowserPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M1 12a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v4h-.5a.5.5 0 0 1-.5-.5V15a3 3 0 0 0-6 0v.5a.5.5 0 0 1-.5.5H15a3 3 0 0 0-2.81 4.05c.15.4-.11.95-.54.95H4a3 3 0 0 1-3-3v-6Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
